import React from "react";
import { Col, Row } from "../../../ApiS/Grid-system/Grid-system";
import Selected from "../../Inputs/Selected";

interface ExamIdProps {}

const ExamId: React.FC<ExamIdProps> = () => {
  return (
    <div className="w-[90%] mx-auto ">
      <>
        <Row className=" border-2 border-Secondary ">
          <Col
            lg={6}
            md={6}
            sm={6}
            className=" border-l-2  p-5 text-center !mb-0"
          >
            <div className="font-bold text-base"> الرقم الامتحاني </div>
          </Col>
          <Col
            lg={6}
            md={6}
            sm={6}
            className="flex items-center justify-center !mb-0"
          >
            <div className="">0000000000000</div>
          </Col>
        </Row>

        <Row className=" border-2 border-Secondary">
          <Col
            lg={6}
            md={6}
            sm={6}
            className=" border-l-2  p-5 text-center !mb-0"
          >
            <div className="font-bold text-base"> الاسم </div>
          </Col>
          <Col
            lg={6}
            md={6}
            sm={6}
            className="flex items-center justify-center !mb-0"
          >
            <div className="">اب عنتر </div>
          </Col>
        </Row>

        <Row className=" border-2 border-Secondary">
          <Col
            lg={6}
            md={6}
            sm={6}
            className=" border-l-2  p-5 text-center !mb-0"
          >
            <div className="font-bold text-base"> النسبة </div>
          </Col>
          <Col
            lg={6}
            md={6}
            sm={6}
            className="flex items-center justify-center !mb-0"
          >
            <div className="">عنترة</div>
          </Col>
        </Row>

        <Row className=" border-2 border-Secondary">
          <Col
            lg={6}
            md={6}
            sm={6}
            className=" border-l-2  p-5 text-center !mb-0"
          >
            <div className="font-bold text-base"> الاب </div>
          </Col>
          <Col
            lg={6}
            md={6}
            sm={6}
            className="flex items-center justify-center !mb-0"
          >
            <div className="">عناتر</div>
          </Col>
        </Row>

        <Row className=" border-2 border-Secondary">
          <Col
            lg={6}
            md={6}
            sm={6}
            className=" border-l-2  p-5 text-center !mb-0"
          >
            <div className="font-bold text-base"> الام </div>
          </Col>
          <Col
            lg={6}
            md={6}
            sm={6}
            className="flex items-center justify-center !mb-0"
          >
            <div className="">ام عنتر</div>
          </Col>
        </Row>

        <Row className=" border-2 border-Secondary">
          <Col
            lg={6}
            md={6}
            sm={6}
            className=" border-l-2  p-5 text-center !mb-0"
          >
            <div className="font-bold text-base"> مكان الضبط</div>
          </Col>
          <Col
            lg={6}
            md={6}
            sm={6}
            className="flex items-center justify-center !mb-0"
          >
            <div className="">القاعة 12 </div>
          </Col>
        </Row>

        <Row className=" border-2 border-Secondary">
          <Col
            lg={6}
            md={6}
            sm={6}
            className=" border-l-2  p-5 text-center !mb-0"
          >
            <div className="font-bold text-base"> اسم المقرر </div>
          </Col>
          <Col
            lg={6}
            md={6}
            sm={6}
            className="flex items-center justify-center !mb-0"
          >
            <div className=""> عربي</div>
          </Col>
        </Row>

        <Row className=" border-2 border-Secondary">
          <Col
            lg={6}
            md={6}
            sm={6}
            className=" border-l-2  p-5 text-center !mb-0"
          >
            <div className="font-bold text-base"> نوع الضبط </div>
          </Col>
          <Col
            lg={6}
            md={6}
            sm={6}
            className="flex items-center justify-center !mb-0"
          >
            <div className=""> شغب</div>
          </Col>
        </Row>
        <Row className=" border-2 border-Secondary">
          <Col
            lg={6}
            md={6}
            sm={6}
            className=" border-l-2  p-5 text-center !mb-0"
          >
            <div className="font-bold text-base"> توقيت الضبط </div>
          </Col>
          <Col
            lg={6}
            md={6}
            sm={6}
            className="flex items-center justify-center !mb-0"
          >
            12/4/2024 10:10 Am
          </Col>
        </Row>

        <Row className=" border-2 border-Secondary">
          <Col
            lg={6}
            md={6}
            sm={6}
            className=" border-l-2  p-5 text-center !mb-0"
          >
            <div className="font-bold text-base"> منظم الضبط </div>
          </Col>
          <Col
            lg={6}
            md={6}
            sm={6}
            className="flex items-center justify-center !mb-0"
          >
            رقم الحساب
          </Col>
        </Row>

        <Row className=" border-2 border-Secondary">
          <Col
            lg={6}
            md={6}
            sm={6}
            className=" border-l-2  p-5 text-center !mb-0"
          >
            <div className="font-bold text-base"> رقم قرار لجنة الانضباط </div>
          </Col>
          <Col
            lg={6}
            md={6}
            sm={6}
            className="flex items-center justify-center !mb-0"
          >
            رقم قرار لجنة الانضباط
          </Col>
        </Row>

        <Row className=" border-2 border-Secondary">
          <Col
            lg={6}
            md={6}
            sm={6}
            className=" border-l-2  p-5 text-center !mb-0"
          >
            <div className="font-bold text-base"> تاريخ القرار </div>
          </Col>
          <Col
            lg={6}
            md={6}
            sm={6}
            className="flex items-center justify-center !mb-0"
          >
            رقم قرار لجنة الانضباط
          </Col>
        </Row>

        <Row className=" border-2 border-Secondary">
          <Col
            lg={6}
            md={6}
            sm={6}
            className=" border-l-2  p-5 text-center !mb-0"
          >
            <div className="font-bold text-base mt-4"> نتيجة القرار</div>
          </Col>
          <Col
            lg={6}
            md={6}
            sm={6}
            className="flex items-center justify-center !mb-0"
          >
            <Selected
              title="  معاقب"
              //   name="payment_method_id"
              // text="أختر اسم المقرر"
              value={""}
              onChange={(e) => {
                //   handleChangeInput(e);
                // setSelectedOptionType(e.target.options[e.target.selectedIndex].dataset.type)
              }}
              className="!w-[300px] max-lg:!w-full mb-5"
            >
              {/* {dataPayment?.data?.data?.map((e) => ( */}
              <option
              // key={e.id} value={e.id} data-type ={e.type}
              >
                {/* {e.name} */}
                React
              </option>
              {/* ))} */}
              <option>HTML</option>
              <option>CSS</option>
              <option>JS</option>
            </Selected>
          </Col>
        </Row>
        <Row className=" border-2 border-Secondary">
          <Col
            lg={6}
            md={6}
            sm={6}
            className=" border-l-2  p-5 text-center !mb-0"
          >
            <div className="font-bold text-base mt-4"> نوع العقوبة</div>
          </Col>
          <Col
            lg={6}
            md={6}
            sm={6}
            className="flex items-center justify-center !mb-0"
          >
            <Selected
              title="  حرمان"
              //   name="payment_method_id"
              // text="أختر اسم المقرر"
              value={""}
              onChange={(e) => {
                //   handleChangeInput(e);
                // setSelectedOptionType(e.target.options[e.target.selectedIndex].dataset.type)
              }}
              className="!w-[300px] max-lg:!w-full mb-5"
            >
              {/* {dataPayment?.data?.data?.map((e) => ( */}
              <option
              // key={e.id} value={e.id} data-type ={e.type}
              >
                {/* {e.name} */}
                React
              </option>
              {/* ))} */}
              <option>HTML</option>
              <option>CSS</option>
              <option>JS</option>
            </Selected>
          </Col>
        </Row>
        <Row className=" border-2 border-Secondary">
          <Col
            lg={12}
            md={12}
            sm={12}
            className=" border-none  p-5 bg-red-100 !mb-0 text-slate-400"
          >
            <div className="font-bold text-base">
              {" "}
              ادخل عدد الدورات التي حرم منها الطالب{" "}
            </div>
          </Col>
        </Row>
        <Row className=" border-2 border-Secondary">
          <Col
            lg={6}
            md={6}
            sm={6}
            className=" border-l-2  p-5  flex items-center justify-center !mb-0"
          >
            <div className="font-bold text-base"> صورة لقرار </div>
          </Col>
          <Col
            lg={6}
            md={6}
            sm={6}
            className="flex items-center justify-center !mb-0"
          >
            {/* <Input placeholder="  صورة القراhhhhhر " className="w-[300px] max-lg:!w-full" 
                     /> */}
            {/* <AddImage
              type="IMAGES"
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              title="صورة القرار"
              name="file"
              className="!bg-Main w-full h-12 mx-8"
              onChange={(e) => {
                // setSuccessPost(0);
                // handleChangeInput(e);
              }}
            /> */}
          </Col>
        </Row>

        <Row className=" border-2 border-Secondary">
          <Col
            lg={6}
            md={6}
            sm={6}
            className=" border-l-2  p-5 text-center !mb-0"
          >
            <div className="font-bold text-base"> قرار لجنة التنظيم </div>
          </Col>
          <Col
            lg={6}
            md={6}
            sm={6}
            className="flex items-center justify-center !mb-0"
          >
            قرار لجنة التنظيم
          </Col>
        </Row>
        <Row className=" border-2 border-Secondary">
          <Col
            lg={6}
            md={6}
            sm={6}
            className=" border-l-2  p-5 text-center !mb-0"
          >
            <div className="font-bold text-base"> تاريخ القرار </div>
          </Col>
          <Col
            lg={6}
            md={6}
            sm={6}
            className="flex items-center justify-center !mb-0"
          >
            12/24/2024 10:10 am
          </Col>
        </Row>
        <Row className=" border-2 border-Secondary">
          <Col
            lg={6}
            md={6}
            sm={6}
            className=" border-l-2  p-5 text-center !mb-0"
          >
            <div className="font-bold text-base mt-4"> نتيجة القرار</div>
          </Col>
          <Col
            lg={6}
            md={6}
            sm={6}
            className="flex items-center justify-center !mb-0"
          >
            <Selected
              title="  تثبيت قرار اللجنة"
              //   name="payment_method_id"
              // text="أختر اسم المقرر"
              value={""}
              onChange={(e) => {
                //   handleChangeInput(e);
                // setSelectedOptionType(e.target.options[e.target.selectedIndex].dataset.type)
              }}
              className="!w-[300px] max-lg:!w-full mb-5"
            >
              {/* {dataPayment?.data?.data?.map((e) => ( */}
              <option
              // key={e.id} value={e.id} data-type ={e.type}
              >
                {/* {e.name} */}
                React
              </option>
              {/* ))} */}
              <option>HTML</option>
              <option>CSS</option>
              <option>JS</option>
            </Selected>
          </Col>
        </Row>
        <Row className=" border-2 border-Secondary">
          <Col
            lg={6}
            md={6}
            sm={6}
            className=" border-l-2  p-5  flex items-center justify-center !mb-0"
          >
            <div className="font-bold text-base"> صورة لقرار </div>
          </Col>
          <Col
            lg={6}
            md={6}
            sm={6}
            className="flex items-center justify-center !mb-0"
          >
            {/* <AddImage
              type="IMAGES"
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              title="صورة القرار"
              name="file"
              className="!bg-Main w-full h-12 mx-8"
              onChange={(e) => {
                // setSuccessPost(0);
                // handleChangeInput(e);
              }}
            /> */}
          </Col>
        </Row>
      </>
    </div>
  );
};

export default ExamId;
